import { observable, makeObservable } from "mobx";

export default class StatementEditorStore {
  statements = [];
  saving;

  constructor() {
    makeObservable(this, {
      statements: observable,
      saving: observable,
    });
  }
}
